export default __webpack_public_path__ + "static/media/physicalLocation-other-1_r1gWFDfpYm.1719043d.jpg";